import api from "../../../../api/api";

const unwrap = (response) => response?.data ?? response;
const basePath = "/user/group-relief/corporate-groups";

export const getCorporateGroups = () =>
  api.get(basePath).then((response) => unwrap(response) || []);

export const createCorporateGroup = (value) =>
  api.post(basePath, value).then(unwrap);

export const updateCorporateGroup = (groupId, value) =>
  api.put(`${basePath}/${encodeURIComponent(groupId)}`, value).then(unwrap);

export const deleteCorporateGroup = (groupId) =>
  api.delete(`${basePath}/${encodeURIComponent(groupId)}`).then(unwrap);
